module.exports = __webpack_public_path__ + "img/4.ded80b65.jpg";